import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:"filterCarStatusTrans"
    ,pure: false
})
export class FilterCarStatusTrans implements PipeTransform {
    transform(item : any) {
        if(!item){
            return item;
        }

        if(
            item.dtgGpsFaultYn === "1"
         || item.dtgSpeedFaultYn === "1"
         || item.dtgRpmFaultYn === "1"
         || item.dtgBrakeFaultYn === "1"
         || item.dtgInputFaultYn === "1"
         || item.dtgOutputFaultYn === "1"
         || item.dtgSaveFaultYn === "1"
         || item.dtgCommFaultYn === "1"
         || item.dtgDistFaultYn === "1"
         || item.dtgPowerFaultYn === "1"
        ){
            return "error";
        }

        if(item.dtgKeyonYn === "1"){
            return "on";
        }

        return "off";
    }
}